import React from 'react';
import {Button, ModalCard} from "@vkontakte/vkui";
import {useRouteNavigator} from "@vkontakte/vk-mini-apps-router";
import {
    MODAL_CARD_CLASS,
    MODAL_HEADER_CLASS,
    MODAL_SECONDARY_BUTTON_CLASS,
    MODAL_SUBHEADER_CLASS
} from "../modalStyles";

export const TournamentGoodLuckModal = ({nav}) => {
    const routeNavigator = useRouteNavigator();

    return (
        <ModalCard
            nav={nav}
            onClose={() => routeNavigator.hideModal()}
            className={MODAL_CARD_CLASS}
            header={<span className={MODAL_HEADER_CLASS}>Good luck in the tournament!</span>}
            subheader={<span className={MODAL_SUBHEADER_CLASS}>You are already subscribed. We will keep you updated.</span>}
            actions={
                <div className={"flex flex-col w-full"}>
                    <Button
                        size="l"
                        mode="secondary"
                        className={MODAL_SECONDARY_BUTTON_CLASS}
                        onClick={() => routeNavigator.hideModal()}
                    >
                        Close
                    </Button>
                </div>
            }
        />
    );
};
